module.exports = __webpack_public_path__ + "static/media/sdmt5.665ecb17.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sdmt/sdmt5.svg
// module id = 345
// module chunks = 0